import React from 'react';
import classNames from 'classnames';
import styles from '../../styles/layout.module.css';

/**
 * Usage:
 * <Column lg={2} md={4} sm={6}>Content</Column>
 */
export default function Column({ lg, md, sm, className, children, ...rest }) {
  const colClasses = [
    lg && styles[`col-${lg}`],
    md && styles[`col-md-${md}`],
    sm && styles[`col-sm-${sm}`],
    className,
  ].filter(Boolean);

  return (
    <div className={classNames(...colClasses)} {...rest}>
      {children}
    </div>
  );
}